import * as React from "react";

import {
  createTheme,
  ThemeOptions,
  ThemeProvider,
} from "@material-ui/core/styles";

import { useBranding } from "client/hooks";
import { cashTheme, themeConfig } from "client/styles";

export const MopThemeProvider: React.FC = ({ children }) => {
  const { brandKey } = useBranding();
  const brandThemeConfig = brandKey == "CashApp" ? cashTheme : themeConfig;

  const theme = createTheme(brandThemeConfig as ThemeOptions);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
